import { render, staticRenderFns } from "./BankEquipTable.vue?vue&type=template&id=4835d760&scoped=true"
import script from "./BankEquipTable.vue?vue&type=script&lang=js"
export * from "./BankEquipTable.vue?vue&type=script&lang=js"
import style0 from "./BankEquipTable.vue?vue&type=style&index=0&id=4835d760&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4835d760",
  null
  
)

export default component.exports